// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import { useCart } from "../../../Context/CartContext";

// const BASE_URL = "https://ecom.cyberathon.com";

// const EbookDetail = () => {
//   const { prod_id } = useParams(); // ← prod_id from route
//   const navigate = useNavigate();
//   const { setCartCount } = useCart();

//   const [ebook, setEbook] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isAdded, setIsAdded] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   // ── Fetch ebook by prod_id ──
//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/index.php/Api/list_pdf`)
//       .then((res) => {
//         if (res.data.status) {
//           const found = res.data.data.find(
//             (item) => String(item.prod_id) === String(prod_id)
//           );
//           setEbook(found || null);
//         }
//       })
//       .catch((err) => console.error(err))
//       .finally(() => setLoading(false));
//   }, [prod_id]);

//   // ── Check if already in cart ──
//   useEffect(() => {
//     if (!ebook) return;

//     const checkCart = async () => {
//       const userId = sessionStorage.getItem("userId");
//       const cartToken = localStorage.getItem("cart_token");
//       if (!userId && !cartToken) return;

//       try {
//         const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//           user_id: userId || null,
//           cart_token: userId ? null : cartToken,
//         });
//         if (res.data.status) {
//           const ids = res.data.cart_items.map((item) => String(item.prod_id));
//           if (ids.includes(String(prod_id))) setIsAdded(true);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     checkCart();
//   }, [ebook]);

//   // ── Add to Cart ──
//   const handleAddToCart = async () => {
//     if (!prod_id) {
//       alert("This item is not available for purchase yet.");
//       return;
//     }

//     const userId = sessionStorage.getItem("userId");
//     if (!userId) {
//       alert("Please login first!");
//       navigate("/login");
//       return;
//     }

//     if (isAdded) return;

//     setIsLoading(true);

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//         user_id: Number(userId),
//         prod_id: Number(prod_id),
//         qty: 1,
//       });

//       if (res.data.status === true) {
//         setIsAdded(true);
//         setCartCount((prev) => prev + 1);
//       } else {
//         alert(res.data.message || "Failed to add to cart");
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Something went wrong");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ── Loading ──
//   if (loading) {
//     return (
//       <>
//         <Layout />
//         <div
//           style={{
//             minHeight: "70vh",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <div className="text-center">
//             <div
//               className="spinner-border"
//               style={{ color: "#24aeb1", width: "3rem", height: "3rem" }}
//               role="status"
//             />
//             <p className="mt-3 text-muted fw-semibold">Loading E-Book...</p>
//           </div>
//         </div>
//         <FooterNew />
//       </>
//     );
//   }

//   // ── Not Found ──
//   if (!ebook) {
//     return (
//       <>
//         <Layout />
//         <div
//           style={{
//             minHeight: "70vh",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexDirection: "column",
//             gap: "12px",
//           }}
//         >
//           <i className="bi bi-journal-x" style={{ fontSize: "64px", color: "#ccc" }}></i>
//           <h4 className="text-muted">E-Book not found</h4>
//           <button
//             onClick={() => navigate(-1)}
//             style={{
//               background: "#24aeb1",
//               color: "#fff",
//               border: "none",
//               padding: "10px 28px",
//               borderRadius: "8px",
//               fontWeight: "600",
//               cursor: "pointer",
//             }}
//           >
//             <i className="bi bi-arrow-left me-2"></i>Go Back
//           </button>
//         </div>
//         <FooterNew />
//       </>
//     );
//   }

//   const hasPrice = ebook.current_price && Number(ebook.current_price) > 0;
//   const hasOldPrice = ebook.old_price && Number(ebook.old_price) > 0;
//   const discountPercent =
//     hasPrice && hasOldPrice
//       ? Math.round(
//           ((Number(ebook.old_price) - Number(ebook.current_price)) /
//             Number(ebook.old_price)) *
//             100
//         )
//       : null;

//   return (
//     <>
//       <Layout />

//       <div style={{ background: "#f8f9fb", minHeight: "100vh", padding: "36px 0 60px" }}>
//         <div className="container">

//           {/* Back Button */}
//           <button
//             onClick={() => navigate(-1)}
//             style={{
//               background: "transparent",
//               border: "none",
//               color: "#24aeb1",
//               fontWeight: "600",
//               fontSize: "14px",
//               cursor: "pointer",
//               marginBottom: "24px",
//               padding: 0,
//               display: "flex",
//               alignItems: "center",
//               gap: "6px",
//             }}
//           >
//             <i className="bi bi-arrow-left"></i> Back to E-Books
//           </button>

//           {/* Main Card */}
//           <div
//             style={{
//               background: "#fff",
//               borderRadius: "20px",
//               boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
//               overflow: "hidden",
//             }}
//           >
//             <div className="row g-0">

//               {/* LEFT — PDF Preview */}
//               <div
//                 className="col-12 col-md-5"
//                 style={{
//                   background: "#f0f2f5",
//                   minHeight: "480px",
//                   position: "relative",
//                 }}
//               >
//                 <iframe
//                   src={`${BASE_URL}/${ebook.pdf}#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
//                   title={ebook.name}
//                   style={{
//                     width: "100%",
//                     height: "100%",
//                     minHeight: "480px",
//                     border: "none",
//                     pointerEvents: "none",
//                   }}
//                 />

//                 {/* E-Book label */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "16px",
//                     left: "16px",
//                     background: "#24aeb1",
//                     color: "#fff",
//                     fontSize: "12px",
//                     fontWeight: "700",
//                     padding: "5px 14px",
//                     borderRadius: "20px",
//                   }}
//                 >
//                   📖 E-Book
//                 </div>
//               </div>

//               {/* RIGHT — Details */}
//               <div className="col-12 col-md-7" style={{ padding: "36px 40px" }}>

//                 {/* Name */}
//                 <h2
//                   style={{
//                     fontWeight: "800",
//                     fontSize: "26px",
//                     color: "#1a1a2e",
//                     marginBottom: "10px",
//                     lineHeight: "1.3",
//                   }}
//                 >
//                   {ebook.name}
//                 </h2>

//                 {/* Description */}
//                 {ebook.description && (
//                   <p
//                     style={{
//                       fontSize: "15px",
//                       color: "#666",
//                       lineHeight: "1.7",
//                       marginBottom: "20px",
//                     }}
//                   >
//                     {ebook.description}
//                   </p>
//                 )}

//                 <hr style={{ borderColor: "#f0f0f0", margin: "20px 0" }} />

//                 {/* Price */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "14px",
//                     marginBottom: "24px",
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   {hasPrice ? (
//                     <>
//                       <span
//                         style={{
//                           fontWeight: "800",
//                           fontSize: "32px",
//                           color: "#27ae60",
//                         }}
//                       >
//                         ₹{Number(ebook.current_price).toLocaleString()}
//                       </span>

//                       {hasOldPrice && (
//                         <span
//                           style={{
//                             fontSize: "18px",
//                             color: "#aaa",
//                             textDecoration: "line-through",
//                           }}
//                         >
//                           ₹{Number(ebook.old_price).toLocaleString()}
//                         </span>
//                       )}

//                       {/* {discountPercent && (
//                         <span
//                           style={{
//                             background: "#e8f9f0",
//                             color: "#27ae60",
//                             fontSize: "13px",
//                             fontWeight: "700",
//                             padding: "4px 12px",
//                             borderRadius: "20px",
//                           }}
//                         >
//                           {discountPercent}% OFF
//                         </span>
//                       )} */}
//                     </>
//                   ) : (
//                     <span style={{ color: "#bbb", fontStyle: "italic", fontSize: "16px" }}>
//                       Price not available
//                     </span>
//                   )}
//                 </div>

//                 {/* Add to Cart Button */}
//                 <div
//                   onClick={handleAddToCart}
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: "10px",
//                     padding: "14px 40px",
//                     borderRadius: "12px",
//                     fontSize: "15px",
//                     fontWeight: "700",
//                     cursor: isAdded || !prod_id ? "default" : "pointer",
//                     background: !prod_id
//                       ? "#e0e0e0"
//                       : isAdded
//                       ? "#24aeb1"
//                       : "#24aeb1",
//                     color: !prod_id ? "#999" : "#fff",
//                     transition: "background 0.3s, transform 0.15s",
//                     userSelect: "none",
//                     marginBottom: "32px",
//                     minWidth: "220px",
//                   }}
//                   onMouseEnter={(e) => {
//                     if (!isAdded && prod_id)
//                       e.currentTarget.style.transform = "scale(1.03)";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.transform = "scale(1)";
//                   }}
//                 >
//                   {isLoading ? (
//                     <span className="spinner-border spinner-border-sm" role="status" />
//                   ) : isAdded ? (
//                     <>
//                       Added <i className="bi bi-check2" style={{ fontSize: "17px" }}></i>
//                     </>
//                   ) : !prod_id ? (
//                     <>
//                       <i className="bi bi-x-circle"></i> Unavailable
//                     </>
//                   ) : (
//                     <>
//                       Add to Cart <i className="bi bi-bag" style={{ fontSize: "16px" }}></i>
//                     </>
//                   )}
//                 </div>

//                 {/* About this E-Book */}
//                 {ebook.details && (
//                   <div
//                     style={{
//                       background: "#f8f9fb",
//                       borderRadius: "12px",
//                       padding: "20px 24px",
//                       borderLeft: "4px solid #24aeb1",
//                       marginBottom: "24px",
//                     }}
//                   >
//                     <h6
//                       style={{
//                         fontWeight: "700",
//                         fontSize: "14px",
//                         color: "#24aeb1",
//                         marginBottom: "10px",
//                         textTransform: "uppercase",
//                         letterSpacing: "0.8px",
//                       }}
//                     >
//                       <i className="bi bi-info-circle me-2"></i>About this E-Book
//                     </h6>
//                     <p
//                       style={{
//                         fontSize: "14px",
//                         color: "#555",
//                         lineHeight: "1.8",
//                         margin: 0,
//                       }}
//                     >
//                       {ebook.details}
//                     </p>
//                   </div>
//                 )}

//                 {/* Meta Info */}
//                 {/* <div
//                   style={{
//                     display: "flex",
//                     gap: "20px",
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "#888", fontSize: "13px" }}>
//                     <i className="bi bi-file-earmark-pdf" style={{ color: "#e74c3c", fontSize: "16px" }}></i>
//                     PDF Format
//                   </div>
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "#888", fontSize: "13px" }}>
//                     <i className="bi bi-download" style={{ color: "#24aeb1", fontSize: "16px" }}></i>
//                     Instant Access
//                   </div>
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "#888", fontSize: "13px" }}>
//                     <i className="bi bi-calendar3" style={{ fontSize: "15px" }}></i>
//                     Added:{" "}
//                     {new Date(ebook.created_at).toLocaleDateString("en-IN", {
//                       day: "numeric",
//                       month: "short",
//                       year: "numeric",
//                     })}
//                   </div>
//                 </div> */}

//               </div>
//             </div>
//           </div>

//         </div>
//       </div>

//       <FooterNew />
//     </>
//   );
// };

// export default EbookDetail;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import { useCart } from "../../../Context/CartContext";
// import styles from "./EbookDetail.module.css";

// const BASE_URL = "https://ecom.cyberathon.com";

// // ── SVG Icons ────────────────────────────────────────────────────────────────
// const ArrowLeft = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M19 12H5M12 5l-7 7 7 7"/>
//   </svg>
// );
// const CartIcon = () => (
//   <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
//     <line x1="3" y1="6" x2="21" y2="6"/>
//     <path d="M16 10a4 4 0 0 1-8 0"/>
//   </svg>
// );
// const CheckIcon = () => (
//   <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="20 6 9 17 4 12"/>
//   </svg>
// );
// const LockIcon = () => (
//   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//     <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
//   </svg>
// );
// const BookOpenIcon = () => (
//   <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
//     <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
//   </svg>
// );
// const FileIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
//     <polyline points="14 2 14 8 20 8"/>
//   </svg>
// );
// const InfoIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <circle cx="12" cy="12" r="10"/>
//     <line x1="12" y1="16" x2="12" y2="12"/>
//     <line x1="12" y1="8" x2="12.01" y2="8"/>
//   </svg>
// );

// // ════════════════════════════════════════════════════════════════════════════
// const EbookDetail = () => {
//   const { prod_id } = useParams();
//   const navigate    = useNavigate();
//   const { setCartCount } = useCart();

//   const [ebook, setEbook]             = useState(null);
//   const [loading, setLoading]         = useState(true);
//   const [isAdded, setIsAdded]         = useState(false);
//   const [isLoading, setIsLoading]     = useState(false);
//   const [isPurchased, setIsPurchased] = useState(false);
//   const [openModal, setOpenModal]     = useState(false);

//   // ── Fetch ebook ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/index.php/Api/list_pdf`)
//       .then((res) => {
//         if (res.data.status) {
//           const found = res.data.data.find(
//             (item) => String(item.prod_id) === String(prod_id)
//           );
//           setEbook(found || null);
//         }
//       })
//       .catch(console.error)
//       .finally(() => setLoading(false));
//   }, [prod_id]);

//   // ── Check cart + purchased ───────────────────────────────────────────────
//   useEffect(() => {
//     if (!ebook) return;
//     const userId    = sessionStorage.getItem("userId");
//     const cartToken = localStorage.getItem("cart_token");

//     const init = async () => {
//       if (userId || cartToken) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//             user_id:    userId || null,
//             cart_token: userId ? null : cartToken,
//           });
//           if (res.data.status) {
//             const ids = res.data.cart_items.map((i) => String(i.prod_id));
//             if (ids.includes(String(prod_id))) setIsAdded(true);
//           }
//         } catch (err) { console.error(err); }
//       }

//       if (userId) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_new_order`, {
//             user_id: parseInt(userId),
//           });
//           if (res.data.status && Array.isArray(res.data.orders)) {
//             for (const order of res.data.orders) {
//               if (!Array.isArray(order.items)) continue;
//               for (const item of order.items) {
//                 if (String(item.prod_id) !== String(prod_id)) continue;
//                 if (
//                   item.access === "unlocked" ||
//                   order.purchase_status === "yes" ||
//                   ["Paid", "paid"].includes(order.payment_status) ||
//                   ["Delivered", "Completed"].includes(order.order_status)
//                 ) {
//                   setIsPurchased(true);
//                   return;
//                 }
//               }
//             }
//           }
//         } catch (err) { console.error(err); }
//       }
//     };

//     init();
//   }, [ebook, prod_id]);

//   // ── Add to Cart ──────────────────────────────────────────────────────────
//   const handleAddToCart = async () => {
//     if (!prod_id) { alert("This item is not available for purchase yet."); return; }
//     const userId = sessionStorage.getItem("userId");
//     if (!userId) { alert("Please login first!"); navigate("/login"); return; }
//     if (isAdded || isLoading) return;

//     setIsLoading(true);
//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//         user_id: Number(userId),
//         prod_id: Number(prod_id),
//         qty: 1,
//       });
//       if (res.data.status === true) {
//         setIsAdded(true);
//         setCartCount((prev) => prev + 1);
//       } else {
//         alert(res.data.message || "Failed to add to cart");
//       }
//     } catch { alert("Something went wrong"); }
//     finally { setIsLoading(false); }
//   };

//   // ── Loading ──────────────────────────────────────────────────────────────
//   if (loading) {
//     return (
//       <>
//         <Layout />
//         <div className={styles.skeletonWrap}>
//           <div className="text-center">
//             <div className={styles.spinner} />
//             <p className={styles.spinnerText}>Loading E-Book…</p>
//           </div>
//         </div>
//         <FooterNew />
//       </>
//     );
//   }

//   // ── Not Found ────────────────────────────────────────────────────────────
//   if (!ebook) {
//     return (
//       <>
//         <Layout />
//         <div className={styles.notFound}>
//           <span className={styles.notFoundIcon}>📖</span>
//           <h4>E-Book not found</h4>
//           <p>The book you're looking for doesn't exist or has been removed.</p>
//           <button className={styles.backBtn} onClick={() => navigate(-1)}>
//             <ArrowLeft /> Go Back
//           </button>
//         </div>
//         <FooterNew />
//       </>
//     );
//   }

//   const hasPrice    = ebook.current_price && Number(ebook.current_price) > 0;
//   const hasOldPrice = ebook.old_price && Number(ebook.old_price) > 0;

//   return (
//     <>
//       <Layout />

//       <div className={`${styles.page} ${styles.wrapper}`}>
//         <div className="container">

//           {/* ── Back ── */}
//           <button className={styles.backBtn} onClick={() => navigate(-1)}>
//             <ArrowLeft /> Back to E-Books
//           </button>

//           {/* ── Hero Card ── */}
//           <div className={styles.heroCard}>

//             {/* LEFT — PDF Preview */}
//             <div className={styles.previewPanel}>
//               {ebook.pdf ? (
//                 <iframe
//                   className={styles.pdfFrame}
//                   src={`${BASE_URL}/${ebook.pdf}#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
//                   title={ebook.name}
//                   style={isPurchased ? {} : { filter: "blur(3px)", opacity: 0.5 }}
//                 />
//               ) : (
//                 <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 80, opacity: 0.2 }}>
//                   📖
//                 </div>
//               )}

//               {!isPurchased && (
//                 <div className={styles.lockedOverlay}>
//                   <div className={styles.lockIcon}><LockIcon /></div>
//                   <p>Purchase to Unlock</p>
//                 </div>
//               )}

//               <div className={styles.previewFooter}>
//                 <span className={styles.previewLabel}>Preview</span>
//                 <span className={styles.pdfBadge}>
//                   <FileIcon /> PDF Format
//                 </span>
//               </div>
//             </div>

//             {/* RIGHT — Details */}
//             <div className={styles.detailsPanel}>

//               {/* ── Scrollable top content ── */}
//               <div className={styles.detailsTop}>

//                 {/* E-Book tag */}
//                 <div className={styles.categoryTag}>
//                   <BookOpenIcon /> E-Book
//                 </div>

//                 {/* Title */}
//                 <h1 className={styles.bookTitle}>
//                   {ebook.name || "Untitled Book"}
//                 </h1>

//                 {/* Description — CKEditor HTML rendered right below title */}
//                 {ebook.description && (
//                   <div
//                     className={styles.ckContent}
//                     dangerouslySetInnerHTML={{ __html: ebook.description }}
//                   />
//                 )}

//                 <hr className={styles.divider} />

//                 {/* Price */}
//                 <div className={styles.priceBlock}>
//                   {hasPrice ? (
//                     <>
//                       <span className={styles.currentPrice} >
//                         <sup>₹</sup>{Number(ebook.current_price).toLocaleString()}
//                       </span>
//                       {hasOldPrice && (
//                         <span className={styles.oldPrice}>
//                           ₹{Number(ebook.old_price).toLocaleString()}
//                         </span>
//                       )}
//                     </>
//                   ) : (
//                     <span className={styles.priceNA}>Price not available</span>
//                   )}
//                 </div>

//                 {/* About / Details */}
//                 {ebook.details && (
//                   <div className={styles.aboutBox}>
//                     <span className={styles.sectionLabel}>
//                       <InfoIcon /> About this E-Book
//                     </span>
//                     {/* <p className={styles.aboutText}>{ebook.details}</p> */}
//                     <div
//   className="form-control"
//   style={{ minHeight: "150px", background: "#f8f9fa" }}
//   dangerouslySetInnerHTML={{ __html: ebook.details }}
// ></div>
//                   </div>
//                 )}

//               </div>

//               {/* ── CTA Button — always at bottom ── */}
//               <div className={styles.cartBtnWrapper}>
//                 <hr className={styles.divider} />
//                 {isPurchased ? (
//                   <button
//                     className={styles.openPdfBtn}
//                     onClick={() => setOpenModal(true)}
//                   >
//                     <BookOpenIcon /> Read E-Book
//                   </button>
//                 ) : (
//                   <button
//                     className={`${styles.addCartBtn}${isAdded ? ` ${styles.added}` : ""}${!prod_id ? ` ${styles.unavailable}` : ""}`}
//                     onClick={handleAddToCart}
//                     disabled={isLoading || isAdded || !prod_id}
//                   >
//                     {isLoading ? (
//                       <span className="spinner-border spinner-border-sm" role="status" />
//                     ) : isAdded ? (
//                       <><CheckIcon /> Added to Cart</>
//                     ) : !prod_id ? (
//                       <>Unavailable</>
//                     ) : (
//                       <><CartIcon /> Add to Cart</>
//                     )}
//                   </button>
//                 )}
//               </div>

//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ── PDF Viewer Modal ── */}
//       {openModal && isPurchased && (
//         <div className={styles.modalOverlay} onClick={() => setOpenModal(false)}>
//           <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
//             <div className={styles.modalHeader}>
//               <p className={styles.modalTitle}>{ebook.name}</p>
//               <button className={styles.modalClose} onClick={() => setOpenModal(false)}>×</button>
//             </div>
//             <div className={styles.modalBody}>
//               <iframe
//                 src={`${BASE_URL}/${ebook.pdf}#toolbar=1&navpanes=0`}
//                 title={ebook.name}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       <FooterNew />
//     </>
//   );
// };

// export default EbookDetail;


// Before 20march claude

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import { useCart } from "../../../Context/CartContext";
// import styles from "./EbookDetail.module.css";

// const BASE_URL = "https://ecom.cyberathon.com";

// // ── SVG Icons ────────────────────────────────────────────────────────────────
// const ArrowLeft = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M19 12H5M12 5l-7 7 7 7"/>
//   </svg>
// );
// const CartIcon = () => (
//   <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
//     <line x1="3" y1="6" x2="21" y2="6"/>
//     <path d="M16 10a4 4 0 0 1-8 0"/>
//   </svg>
// );
// const CheckIcon = () => (
//   <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="20 6 9 17 4 12"/>
//   </svg>
// );
// const LockIcon = () => (
//   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//     <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
//   </svg>
// );
// const BookOpenIcon = () => (
//   <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
//     <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
//   </svg>
// );
// const FileIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
//     <polyline points="14 2 14 8 20 8"/>
//   </svg>
// );
// const InfoIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <circle cx="12" cy="12" r="10"/>
//     <line x1="12" y1="16" x2="12" y2="12"/>
//     <line x1="12" y1="8" x2="12.01" y2="8"/>
//   </svg>
// );

// // ════════════════════════════════════════════════════════════════════════════
// const EbookDetail = () => {
//   // ✅ Route: /EbookDetail/:prod_id  — prod_id comes from URL
//   const { prod_id }      = useParams();
//   const navigate         = useNavigate();
//   const { setCartCount } = useCart();

//   const [ebook, setEbook]             = useState(null);
//   const [loading, setLoading]         = useState(true);
//   const [isAdded, setIsAdded]         = useState(false);
//   const [isLoading, setIsLoading]     = useState(false);
//   const [isPurchased, setIsPurchased] = useState(false);
//   const [openModal, setOpenModal]     = useState(false);

//   // ── Fetch ebook from list_get_product, find by prod_id ──────────────────
//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/index.php/Api/list_get_product`)
//       .then((res) => {
//         if (res.data?.status && Array.isArray(res.data.products)) {
//           // ✅ Filter ebooks only, then find the one matching prod_id from URL
//           const ebooksOnly = res.data.products.filter(
//             (item) => item.product_type?.toLowerCase() === "ebook"
//           );
//           const found = ebooksOnly.find(
//             (item) => String(item.prod_id) === String(prod_id)
//           );

//           if (found) {
//             // ✅ Normalize fields — ebook uses "name" not "heading"
//             setEbook({
//               prod_id:       found.prod_id,
//               name:          found.name || found.Product_name || "Untitled Book",
//               description:   found.description || "",
//               details:       found.details || "",
//               pdf:           found.pdf || "",
//               current_price: found.current_price || 0,
//               old_price:     found.old_price || 0,
//             });
//           } else {
//             setEbook(null);
//           }
//         }
//       })
//       .catch(console.error)
//       .finally(() => setLoading(false));
//   }, [prod_id]);

//   // ── Check cart + purchased status ────────────────────────────────────────
//   useEffect(() => {
//     if (!ebook) return;
//     const userId    = sessionStorage.getItem("userId");
//     const cartToken = localStorage.getItem("cart_token");

//     const init = async () => {
//       // Cart check
//       if (userId || cartToken) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//             user_id:    userId || null,
//             cart_token: userId ? null : cartToken,
//           });
//           if (res.data.status) {
//             const ids = res.data.cart_items.map((i) => String(i.prod_id));
//             if (ids.includes(String(prod_id))) setIsAdded(true);
//           }
//         } catch (err) { console.error(err); }
//       }

//       // Purchase check
//       if (userId) {
//         try {
//           const res = await axios.post(`${BASE_URL}/index.php/Api/list_new_order`, {
//             user_id: parseInt(userId),
//           });
//           if (res.data.status && Array.isArray(res.data.orders)) {
//             for (const order of res.data.orders) {
//               if (!Array.isArray(order.items)) continue;
//               for (const item of order.items) {
//                 if (String(item.prod_id) !== String(prod_id)) continue;
//                 if (
//                   item.access === "unlocked" ||
//                   order.purchase_status === "yes" ||
//                   ["Paid", "paid"].includes(order.payment_status) ||
//                   ["Delivered", "Completed"].includes(order.order_status)
//                 ) {
//                   setIsPurchased(true);
//                   return;
//                 }
//               }
//             }
//           }
//         } catch (err) { console.error(err); }
//       }
//     };

//     init();
//   }, [ebook, prod_id]);

//   // ── Add to Cart ──────────────────────────────────────────────────────────
//   const handleAddToCart = async () => {
//     if (!prod_id) { alert("This item is not available for purchase yet."); return; }
//     const userId = sessionStorage.getItem("userId");
//     if (!userId) { 
//     sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
//     window.dispatchEvent(new Event("openLoginModal"));  
//       return;
//      }
//     if (isAdded || isLoading) return;

//     setIsLoading(true);
//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//         user_id: Number(userId),
//         prod_id: Number(prod_id),
//         qty: 1,
//       });
//       if (res.data.status === true) {
//         setIsAdded(true);
//         setCartCount((prev) => prev + 1);
//       } else {
//         alert(res.data.message || "Failed to add to cart");
//       }
//     } catch { alert("Something went wrong"); }
//     finally { setIsLoading(false); }
//   };

//   // ── Loading ──────────────────────────────────────────────────────────────
//   if (loading) {
//     return (
//       <>
//         <Layout />
//         <div className={styles.skeletonWrap}>
//           <div className="text-center">
//             <div className={styles.spinner} />
//             <p className={styles.spinnerText}>Loading E-Book…</p>
//           </div>
//         </div>
//         <FooterNew />
//       </>
//     );
//   }

//   // ── Not Found ────────────────────────────────────────────────────────────
//   if (!ebook) {
//     return (
//       <>
//         <Layout />
//         <div className={styles.notFound}>
//           <span className={styles.notFoundIcon}>📖</span>
//           <h4>E-Book not found</h4>
//           <p>The book you're looking for doesn't exist or has been removed.</p>
//           <button className={styles.backBtn} onClick={() => navigate(-1)}>
//             <ArrowLeft /> Go Back
//           </button>
//         </div>
//         <FooterNew />
//       </>
//     );
//   }

//   const hasPrice    = ebook.current_price && Number(ebook.current_price) > 0;
//   const hasOldPrice = ebook.old_price && Number(ebook.old_price) > 0;

//   return (
//     <>
//       <Layout />

//       <div className={`${styles.page} ${styles.wrapper}`}>
//         <div className="container">

//           {/* Back button */}
//           <button className={styles.backBtn} onClick={() => navigate(-1)}>
//             <ArrowLeft /> Back to E-Books
//           </button>

//           {/* Hero Card */}
//           <div className={styles.heroCard}>

//             {/* LEFT — PDF Preview */}
//             <div className={styles.previewPanel}>
//               {ebook.pdf ? (
//                 <iframe
//                   className={styles.pdfFrame}
//                   src={`${BASE_URL}/${ebook.pdf}#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
//                   title={ebook.name}
//                   style={isPurchased ? {} : { filter: "blur(3px)", opacity: 0.5 }}
//                 />
//               ) : (
//                 <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 80, opacity: 0.2 }}>
//                   📖
//                 </div>
//               )}

//               {!isPurchased && (
//                 <div className={styles.lockedOverlay}>
//                   <div className={styles.lockIcon}><LockIcon /></div>
//                   <p>Purchase to Unlock</p>
//                 </div>
//               )}

//               <div className={styles.previewFooter}>
//                 <span className={styles.previewLabel}>Preview</span>
//                 <span className={styles.pdfBadge}>
//                   <FileIcon /> PDF Format
//                 </span>
//               </div>
//             </div>

//             {/* RIGHT — Details */}
//             <div className={styles.detailsPanel}>

//               <div className={styles.detailsTop}>

//                 {/* E-Book tag */}
//                 <div className={styles.categoryTag}>
//                   <BookOpenIcon /> E-Book
//                 </div>

//                 {/* Title */}
//                 <h1 className={styles.bookTitle}>
//                   {ebook.name}
//                 </h1>

//                 {/* Description */}
//                 {ebook.description && (
//                   <div
//                     className={styles.ckContent}
//                     dangerouslySetInnerHTML={{ __html: ebook.description }}
//                   />
//                 )}

//                 <hr className={styles.divider} />

//                 {/* Price */}
//                 <div className={styles.priceBlock}>
//                   {hasPrice ? (
//                     <>
//                       <span className={styles.currentPrice}>
//                         <sup>₹</sup>{Number(ebook.current_price).toLocaleString()}
//                       </span>
//                       {hasOldPrice && (
//                         <span className={styles.oldPrice}>
//                           ₹{Number(ebook.old_price).toLocaleString()}
//                         </span>
//                       )}
//                     </>
//                   ) : (
//                     <span className={styles.priceNA}>Price not available</span>
//                   )}
//                 </div>

//                 {/* Details / About */}
//                 {ebook.details && (
//                   <div className={styles.aboutBox}>
//                     <span className={styles.sectionLabel}>
//                       <InfoIcon /> About this E-Book
//                     </span>
//                     <div
//                       className="form-control"
//                       style={{ minHeight: "150px", background: "#f8f9fa" }}
//                       dangerouslySetInnerHTML={{ __html: ebook.details }}
//                     />
//                   </div>
//                 )}

//               </div>

//               {/* CTA Button — always at bottom */}
//               <div className={styles.cartBtnWrapper}>
//                 <hr className={styles.divider} />
//                 {isPurchased ? (
//                   <button
//                     className={styles.openPdfBtn}
//                     onClick={() => setOpenModal(true)}
//                   >
//                     <BookOpenIcon /> Read E-Book
//                   </button>
//                 ) : (
//                   <button
//                     className={`${styles.addCartBtn}${isAdded ? ` ${styles.added}` : ""}${!prod_id ? ` ${styles.unavailable}` : ""}`}
//                     onClick={handleAddToCart}
//                     disabled={isLoading || isAdded || !prod_id}
//                   >
//                     {isLoading ? (
//                       <span className="spinner-border spinner-border-sm" role="status" />
//                     ) : isAdded ? (
//                       <><CheckIcon /> Added to Cart</>
//                     ) : !prod_id ? (
//                       <>Unavailable</>
//                     ) : (
//                       <><CartIcon /> Add to Cart</>
//                     )}
//                   </button>
//                 )}
//               </div>

//             </div>
//           </div>
//         </div>
//       </div>

//       {/* PDF Viewer Modal */}
//       {openModal && isPurchased && (
//         <div className={styles.modalOverlay} onClick={() => setOpenModal(false)}>
//           <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
//             <div className={styles.modalHeader}>
//               <p className={styles.modalTitle}>{ebook.name}</p>
//               <button className={styles.modalClose} onClick={() => setOpenModal(false)}>×</button>
//             </div>
//             <div className={styles.modalBody}>
//               <iframe
//                 src={`${BASE_URL}/${ebook.pdf}#toolbar=1&navpanes=0`}
//                 title={ebook.name}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       <FooterNew />
//     </>
//   );
// };

// export default EbookDetail;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../Layout/Layout";
import FooterNew from "../../Layout/FooterNew";
import { useCart } from "../../../Context/CartContext";
import styles from "./EbookDetail.module.css";
import SEO from "../../SEO";

const BASE_URL = "https://ecom.cyberathon.com";

// ── Guest cart token ──────────────────────────────────────────────────────────
const getCartToken = () => {
  let token = localStorage.getItem("cart_token");
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem("cart_token", token);
  }
  return token;
};

// ── SVG Icons ─────────────────────────────────────────────────────────────────
const ArrowLeft = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 12H5M12 5l-7 7 7 7"/>
  </svg>
);
const CartIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
  </svg>
);
const CheckIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const LockIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);
const BookOpenIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
  </svg>
);
const FileIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
  </svg>
);
const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="16" x2="12" y2="12"/>
    <line x1="12" y1="8" x2="12.01" y2="8"/>
  </svg>
);

// ── Add to Cart API (guest + logged-in) ───────────────────────────────────────
async function addToCartApi(prod_id, onSuccess, onError) {
  const userId    = sessionStorage.getItem("userId");
  const cartToken = !userId ? getCartToken() : null;

  if (!userId) {
    // Guest: try with cart_token
    try {
      const listRes = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
        user_id: null, cart_token: cartToken,
      });
      if (listRes.data.status) {
        const exists = listRes.data.cart_items.find(
          (i) => String(i.prod_id) === String(prod_id)
        );
        if (exists) { onSuccess(); return; }
      }
      const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
        user_id: null, prod_id: Number(prod_id), qty: 1, cart_token: cartToken,
      });
      if (res.data.status === true) {
        onSuccess();
      } else {
        // Guest cart not supported → open login
        sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
        window.dispatchEvent(new Event("openLoginModal"));
      }
    } catch (e) {
      console.error(e);
      sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
      window.dispatchEvent(new Event("openLoginModal"));
    }
    return;
  }

  // Logged-in
  try {
    const listRes = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
      user_id: userId, cart_token: null,
    });
    if (listRes.data.status) {
      const exists = listRes.data.cart_items.find(
        (i) => String(i.prod_id) === String(prod_id)
      );
      if (exists) { onSuccess(); return; }
    }
    const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
      user_id: Number(userId), prod_id: Number(prod_id), qty: 1,
    });
    if (res.data.status === true) onSuccess();
    else onError(res.data.message || "Failed to add");
  } catch (e) {
    console.error(e);
    onError("Something went wrong");
  }
}

// ── Buy Now API (add to cart → /Bill) ────────────────────────────────────────
// async function buyNowApi(prod_id, navigate, onError, setLoading) {
//   const userId    = sessionStorage.getItem("userId");
//   const cartToken = !userId ? getCartToken() : null;

//   if (!prod_id) { onError("This item is not available."); return; }

//   if (!userId) {
//     sessionStorage.setItem("redirectAfterLogin", "/Bill");
//     sessionStorage.setItem("buyNowProdId", String(prod_id));
//     window.dispatchEvent(new Event("openLoginModal"));
//     setLoading(false);
//     return;
//   }

//   try {
//     const listRes = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//       user_id: userId, cart_token: null,
//     });
//     let cartItem = null;
//     if (listRes.data.status) {
//       cartItem = listRes.data.cart_items.find(
//         (i) => String(i.prod_id) === String(prod_id)
//       );
//     }

//     if (cartItem) {
//       navigate("/Bill");
//     } else {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, {
//         user_id: Number(userId), prod_id: Number(prod_id), qty: 1,
//       });
//       if (res.data.status === true) navigate("/Bill");
//       else onError(res.data.message || "Failed. Please try again.");
//     }
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   } finally {
//     setLoading(false);
//   }
// }
// async function buyNowApi(ebook, navigate, onError, setLoading) {
//   const userId = sessionStorage.getItem("userId");

//   if (!ebook?.prod_id) { onError("This item is not available."); return; }

//   if (!userId) {
//     sessionStorage.setItem("redirectAfterLogin", "/Bill");
//     window.dispatchEvent(new Event("openLoginModal"));
//     setLoading(false);
//     return;
//   }

//   const buyNowProduct = {
//     prod_id: ebook.prod_id,
//     Product_name: ebook.name,
//     current_price: ebook.current_price,
//     qty: 1,
//     size: "",
//     Product_image: ebook.pdf || ""
//   };

//   // navigate("/Bill", {
//   //   state: {
//   //     buyNow: true,
//   //     product: buyNowProduct
//   //   }
//   // });
// sessionStorage.setItem("buyNowProduct", JSON.stringify(buyNowProduct));

// navigate("/Bill");
//   setLoading(false);
// }
async function buyNowApi(ebook, navigate, onError, setLoading) {

  const userId = sessionStorage.getItem("userId");

  if (!ebook?.prod_id) {
    onError("This item is not available.");
    return;
  }

  const buyNowProduct = {
    prod_id: ebook.prod_id,
    Product_name: ebook.name,
    current_price: ebook.current_price,
    qty: 1,
    size: "",
    Product_image: ebook.pdf || ""
  };

  // ✅ Always save product first
  sessionStorage.setItem(
    "buyNowProduct",
    JSON.stringify(buyNowProduct)
  );

  if (!userId) {

    sessionStorage.setItem("redirectAfterLogin", "/Bill");

    window.dispatchEvent(new Event("openLoginModal"));

    setLoading(false);
    return;
  }

  navigate("/Bill");

  setLoading(false);
}
// ════════════════════════════════════════════════════════════════════════════
const EbookDetail = () => {
  const { prod_id }      = useParams();
  const navigate         = useNavigate();
  const { setCartCount } = useCart();

  const [ebook, setEbook]             = useState(null);
  const [loading, setLoading]         = useState(true);
  const [isAdded, setIsAdded]         = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [buyLoading, setBuyLoading]   = useState(false);
  const [isPurchased, setIsPurchased] = useState(false);
  const [openModal, setOpenModal]     = useState(false);
const [seoData, setSeoData] = useState({});
  // ── Fetch ebook ─────────────────────────────────────────────────────────
  useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/index.php/Api/get_seo_by_page`, {
        page_name: 'ebooks_detail'   // <-- Important! page_name 'ebooks' rakho
      });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  useEffect(() => {
    axios
      .get(`${BASE_URL}/index.php/Api/list_get_product`)
      .then((res) => {
        if (res.data?.status && Array.isArray(res.data.products)) {
          const ebooksOnly = res.data.products.filter(
            (item) => item.product_type?.toLowerCase() === "ebook"
          );
          const found = ebooksOnly.find(
            (item) => String(item.prod_id) === String(prod_id)
          );
          if (found) {
            setEbook({
              prod_id:       found.prod_id,
              name:          found.name || found.Product_name || "Untitled Book",
              description:   found.description || "",
              details:       found.details || "",
              pdf:           found.pdf || "",
              current_price: found.current_price || 0,
              old_price:     found.old_price || 0,
            });
          } else {
            setEbook(null);
          }
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [prod_id]);

  // ── Cart + purchased check (guest & logged-in) ──────────────────────────
  useEffect(() => {
    if (!ebook) return;
    const userId    = sessionStorage.getItem("userId");
    // Guest cart_token bhi check karo
    const cartToken = localStorage.getItem("cart_token");

    const init = async () => {
      if (userId || cartToken) {
        try {
          const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
            user_id:    userId || null,
            cart_token: userId ? null : cartToken,
          });
          if (res.data.status) {
            const ids = res.data.cart_items.map((i) => String(i.prod_id));
            if (ids.includes(String(prod_id))) setIsAdded(true);
          }
        } catch (err) { console.error(err); }
      }

      if (userId) {
        try {
          const res = await axios.post(`${BASE_URL}/index.php/Api/list_new_order`, {
            user_id: parseInt(userId),
          });
          if (res.data.status && Array.isArray(res.data.orders)) {
            for (const order of res.data.orders) {
              if (!Array.isArray(order.items)) continue;
              for (const item of order.items) {
                if (String(item.prod_id) !== String(prod_id)) continue;
                if (
                  item.access === "unlocked" ||
                  order.purchase_status === "yes" ||
                  ["Paid", "paid"].includes(order.payment_status) ||
                  ["Delivered", "Completed"].includes(order.order_status)
                ) {
                  setIsPurchased(true);
                  return;
                }
              }
            }
          }
        } catch (err) { console.error(err); }
      }
    };

    init();

    // Re-check on login
    const onLogin = () => init();
    window.addEventListener("userLoggedIn", onLogin);
    return () => window.removeEventListener("userLoggedIn", onLogin);
  }, [ebook, prod_id]);

  // ── Add to Cart handler ─────────────────────────────────────────────────
  const handleAddToCart = () => {
    if (!prod_id || cartLoading || isAdded) return;
    setCartLoading(true);
    addToCartApi(
      prod_id,
      () => {
        setIsAdded(true);
        setCartCount((prev) => prev + 1);
        setCartLoading(false);
      },
      (msg) => {
        alert(msg);
        setCartLoading(false);
      }
    );
  };

  // ── Buy Now handler ─────────────────────────────────────────────────────
  // const handleBuyNow = () => {
  //   if (!prod_id || buyLoading) return;
  //   setBuyLoading(true);
  //   buyNowApi(prod_id, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
  // };

  const handleBuyNow = () => {
  if (!prod_id || buyLoading) return;
  setBuyLoading(true);
  buyNowApi(
    ebook,        // ← prod_id ki jagah poora ebook object
    navigate,
    (msg) => { alert(msg); setBuyLoading(false); },
    setBuyLoading
  );
};

  // ── Loading state ────────────────────────────────────────────────────────
  if (loading) {
    return (
      <>
        <Layout />
        <div className={styles.skeletonWrap}>
          <div className="text-center">
            <div className={styles.spinner} />
            <p className={styles.spinnerText}>Loading E-Book…</p>
          </div>
        </div>
        <FooterNew />
      </>
    );
  }

  // ── Not Found ────────────────────────────────────────────────────────────
  if (!ebook) {
    return (
      <>
        <Layout />
        <div className={styles.notFound}>
          <span className={styles.notFoundIcon}>📖</span>
          <h4>E-Book not found</h4>
          <p>The book you're looking for doesn't exist or has been removed.</p>
          <button className={styles.backBtn} onClick={() => navigate(-1)}>
            <ArrowLeft /> Go Back
          </button>
        </div>
        <FooterNew />
      </>
    );
  }

  const hasPrice    = ebook.current_price && Number(ebook.current_price) > 0;
  const hasOldPrice = ebook.old_price && Number(ebook.old_price) > 0;

  return (
    <>
     <SEO
    title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
    description={seoData.description || "Explore our wide collection of E-Books on programming, design, and more."}
    keywords={seoData.keywords || "ebooks, shopindia, buy ebooks, online books, programming ebooks, design ebooks"}
    canonical={seoData.canonical || "https://www.shopindia.com/ebooks"}
  />
      <Layout />

      {/* Inline styles for new buttons (keeps existing CSS module intact) */}
      <style>{`
        .ed-action-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          margin-top: 4px;
        }
        .ed-btn-cart {
          display: flex; align-items: center; justify-content: center; gap: 8px;
          padding: 13px 0; border-radius: 12px;
          border: 1.5px solid #24aeb1;
          font-size: 14px; font-weight: 700; cursor: pointer;
          background:linear-gradient(135deg, #24aeb1, #058587); color:white;
          width: 100%; letter-spacing: 0.2px;
          transition: background 0.2s, color 0.2s, transform 0.15s;
          font-family: inherit;
        }
        .ed-btn-cart:hover:not(.added):not(:disabled) {
          background: #24aeb1; color: #fff; transform: translateY(-1px);
        }
        .ed-btn-cart.added {
          background: #24aeb1; border-color: #24aeb1;
          color: white; cursor: default;
        }
        .ed-btn-cart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

        .ed-btn-buy {
          display: flex; align-items: center; justify-content: center; gap: 8px;
          padding: 13px 0; border-radius: 12px; border: none;
          font-size: 14px; font-weight: 700; cursor: pointer;
          background:linear-gradient(135deg, #24aeb1, #058587);
          color: #fff; width: 100%; letter-spacing: 0.2px;
          transition: opacity 0.2s, transform 0.15s;
          box-shadow: 0 2px 12px rgba(18, 215, 225, 0.3);
          font-family: inherit;
        }
        .ed-btn-buy:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
        .ed-btn-buy:disabled { opacity: 0.65; cursor: not-allowed; }

        .ed-spinner {
          display: inline-block; width: 15px; height: 15px;
          border: 2px solid rgba(255,255,255,0.35);
          border-top-color: currentColor;
          border-radius: 50%; animation: edSpin 0.7s linear infinite;
        }
        @keyframes edSpin { to { transform: rotate(360deg); } }

        @media (max-width: 480px) {
          .ed-action-row { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className={`${styles.page} ${styles.wrapper}`}>
        <div className="container">

          {/* Back button */}
          <button className={styles.backBtn} onClick={() => navigate(-1)}>
            <ArrowLeft /> Back to E-Books
          </button>

          {/* Hero Card */}
          <div className={styles.heroCard}>

            {/* LEFT — PDF Preview */}
            <div className={styles.previewPanel}>
              {ebook.pdf ? (
                <iframe
                  className={styles.pdfFrame}
                  src={`${BASE_URL}/${ebook.pdf}#page=1&view=FitH&toolbar=0&navpanes=0&scrollbar=0`}
                  title={ebook.name}
                  style={isPurchased ? {} : { filter: "blur(3px)", opacity: 0.5 }}
                />
              ) : (
                <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 80, opacity: 0.2 }}>
                  📖
                </div>
              )}

              {!isPurchased && (
                <div className={styles.lockedOverlay}>
                  <div className={styles.lockIcon}><LockIcon /></div>
                  <p>Purchase to Unlock</p>
                </div>
              )}

              <div className={styles.previewFooter}>
                <span className={styles.previewLabel}>Preview</span>
                <span className={styles.pdfBadge}>
                  <FileIcon /> PDF Format
                </span>
              </div>
            </div>

            {/* RIGHT — Details */}
            <div className={styles.detailsPanel}>

              <div className={styles.detailsTop}>

                {/* E-Book tag */}
                <div className={styles.categoryTag}>
                  <BookOpenIcon /> E-Book
                </div>

                {/* Title */}
                <h1 className={styles.bookTitle}>{ebook.name}</h1>

                {/* Description */}
                {ebook.description && (
                  <div
                    className={styles.ckContent}
                    dangerouslySetInnerHTML={{ __html: ebook.description }}
                  />
                )}

                <hr className={styles.divider} />

                {/* Price */}
                <div className={styles.priceBlock}>
                  {hasPrice ? (
                    <>
                      <span className={styles.currentPrice}>
                        <sup>₹</sup>{Number(ebook.current_price).toLocaleString("en-IN")}
                      </span>
                      {hasOldPrice && (
                        <span className={styles.oldPrice}>
                          ₹{Number(ebook.old_price).toLocaleString("en-IN")}
                        </span>
                      )}
                    </>
                  ) : (
                    <span className={styles.priceNA}>Price not available</span>
                  )}
                </div>

                {/* Details / About */}
                {ebook.details && (
                  <div className={styles.aboutBox}>
                    <span className={styles.sectionLabel}>
                      <InfoIcon /> About this E-Book
                    </span>
                    <div
                      className="form-control"
                      style={{ minHeight: "150px", background: "#f8f9fa" }}
                      dangerouslySetInnerHTML={{ __html: ebook.details }}
                    />
                  </div>
                )}
              </div>

              {/* CTA Buttons — always at bottom */}
              <div className={styles.cartBtnWrapper}>
                <hr className={styles.divider} />

                {isPurchased ? (
                  // Purchased → Read E-Book
                  <button
                    className={styles.openPdfBtn}
                    onClick={() => setOpenModal(true)}
                  >
                    <BookOpenIcon /> Read E-Book
                  </button>

                ) : !prod_id ? (
                  // No prod_id → unavailable
                  <button className={`${styles.addCartBtn} ${styles.unavailable}`} disabled>
                    Unavailable
                  </button>

                ) : (
                  // Add to Cart + Buy Now
                  <div className="ed-action-row">

                    {/* Add to Cart */}
                    <button
                      className={`ed-btn-cart${isAdded ? " added" : ""}`}
                      onClick={handleAddToCart}
                      disabled={cartLoading || isAdded}
                    >
                      {cartLoading ? (
                        <span className="ed-spinner" />
                      ) : isAdded ? (
                        <><CheckIcon /> Added to Cart</>
                      ) : (
                        <><CartIcon /> Add to Cart</>
                      )}
                    </button>

                    {/* Buy Now */}
                    <button
                      className="ed-btn-buy"
                      onClick={handleBuyNow}
                      disabled={buyLoading}
                    >
                      {buyLoading
                        ? <span className="ed-spinner" style={{ borderTopColor: "#fff" }} />
                        : "Buy Now"
                      }
                    </button>

                  </div>
                )}
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* PDF Viewer Modal */}
      {openModal && isPurchased && (
        <div className={styles.modalOverlay} onClick={() => setOpenModal(false)}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <p className={styles.modalTitle}>{ebook.name}</p>
              <button className={styles.modalClose} onClick={() => setOpenModal(false)}>×</button>
            </div>
            <div className={styles.modalBody}>
              <iframe
                src={`${BASE_URL}/${ebook.pdf}#toolbar=1&navpanes=0`}
                title={ebook.name}
              />
            </div>
          </div>
        </div>
      )}

      <FooterNew />
    </>
  );
};

export default EbookDetail;